import { api } from '../api.js';
import { store } from '../store.js';
import { navigate } from '../router.js';

export async function renderRegisterPage({ root }) {
  renderForm(root);
}

function renderForm(root) {
  root.innerHTML = `
    <div class="auth-wrapper">
      <form class="auth-card" id="register-form">
        <h1>Регистрация</h1>
        <div class="form-error" id="form-error"></div>
        <div class="field">
          <label for="email">Email</label>
          <input type="email" id="email" name="email" required autocomplete="email" />
        </div>
        <div class="field">
          <label for="password">Пароль (мин. 8 символов)</label>
          <input type="password" id="password" name="password" required minlength="8" autocomplete="new-password" />
        </div>
        <div class="field">
          <label for="password2">Повторите пароль</label>
          <input type="password" id="password2" name="password2" required minlength="8" autocomplete="new-password" />
        </div>
        <div class="actions">
          <button type="submit" id="submit-btn">Создать аккаунт</button>
        </div>
        <div class="alt">
          Уже есть аккаунт? <a href="/login" data-link>Войти</a>
        </div>
      </form>
    </div>
  `;

  const form = root.querySelector('#register-form');
  const errEl = root.querySelector('#form-error');
  const btn = root.querySelector('#submit-btn');

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    errEl.textContent = '';
    const fd = new FormData(form);
    const email = fd.get('email');
    const password = fd.get('password');
    const password2 = fd.get('password2');
    if (password !== password2) {
      errEl.textContent = 'Пароли не совпадают';
      return;
    }
    btn.disabled = true;
    try {
      const { user } = await api.auth.register(email, password);
      store.user = user;
      navigate('/verify-email');
    } catch (err) {
      if (err.status === 403 && err.body?.error === 'limit_reached') {
        renderWaitlist(root, email);
        return;
      }
      if (err.status === 409) errEl.textContent = 'Этот email уже зарегистрирован';
      else if (err.status === 400) errEl.textContent = 'Проверьте корректность данных (минимум 8 символов в пароле)';
      else errEl.textContent = 'Ошибка: ' + (err.message || 'попробуйте снова');
    } finally {
      btn.disabled = false;
    }
  });
}

function renderWaitlist(root, prefilledEmail) {
  root.innerHTML = `
    <div class="auth-wrapper">
      <form class="auth-card" id="waitlist-form">
        <h1>Бета-тест переполнен 🚦</h1>
        <p class="text-muted">
          Сейчас мы держим ограничение на количество активных пользователей, чтобы не перегружать сервер на бета-тесте.
          Оставь свои данные — мы пригласим тебя, как только освободятся места.
        </p>
        <div class="form-error" id="form-error"></div>
        <div class="field">
          <label for="w-email">Email</label>
          <input type="email" id="w-email" name="email" required value="${escapeHtml(prefilledEmail || '')}" />
        </div>
        <div class="field">
          <label for="w-name">Как тебя зовут? <span class="text-muted">(необязательно)</span></label>
          <input type="text" id="w-name" name="name" maxlength="120" />
        </div>
        <div class="field">
          <label for="w-comment">Расскажи о себе <span class="text-muted">(необязательно)</span></label>
          <textarea id="w-comment" name="comment" rows="3" maxlength="2000" placeholder="Зачем тебе тренажёр? Что хочешь прокачать?"></textarea>
        </div>
        <div class="actions">
          <button type="submit" id="w-submit">Записаться в лист ожидания</button>
        </div>
        <div class="alt">
          <a href="/login" data-link>Уже есть аккаунт? Войти</a>
        </div>
      </form>
    </div>
  `;
  const form = root.querySelector('#waitlist-form');
  const errEl = root.querySelector('#form-error');
  const btn = root.querySelector('#w-submit');
  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    errEl.textContent = '';
    btn.disabled = true;
    const fd = new FormData(form);
    try {
      await api.auth.waitlist({
        email: fd.get('email'),
        name: fd.get('name') || undefined,
        comment: fd.get('comment') || undefined,
      });
      renderWaitlistThanks(root);
    } catch (err) {
      if (err.status === 400) errEl.textContent = 'Проверь email и попробуй снова';
      else errEl.textContent = 'Ошибка: ' + (err.message || 'попробуйте снова');
    } finally {
      btn.disabled = false;
    }
  });
}

function renderWaitlistThanks(root) {
  root.innerHTML = `
    <div class="auth-wrapper">
      <div class="auth-card text-center">
        <h1>Спасибо! ✨</h1>
        <p class="text-muted">
          Записали тебя в лист ожидания. Когда бета-тест откроется для большего числа пользователей —
          напишем тебе на указанный email.
        </p>
        <div class="actions"><a class="btn" href="/login" data-link>На вход</a></div>
      </div>
    </div>
  `;
}

function escapeHtml(s) {
  return String(s ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}
